import Vue from 'vue'
import store from "../store"
import u from "./utils";
const utils = u.methods;
import { auth, subscriber } from '@/services/';
export default {
    methods: {
        init_session: async function () {
            var mun = utils.utils_get_cookies("MUN"), must = utils.utils_get_cookies("MUST");
            if (_.isNull(mun) || mun == "") {
                if (_.isNull(must) || must == "") {
                    this.redirect_to_auth();
                    return false;
                }
                return true;
            } else {
                var response = await auth.check_mun(utils.utils_get_cookies("MUN"));
                if (_.isUndefined(response.jwt_token)) {
                    this.redirect_to_auth();
                    return false;
                } else {
                    utils.utils_delete_cookies("MUN");
                    utils.utils_set_cookies("MUST", response.jwt_token, response.expires_in / 60);
                    return true;
                }
            }
        },
        redirect_to_auth: function () {
            var mun = this.set_mun();
            var params = $.param({
                nonce: mun,
                redirect_uri: window.location.href,
                client_id: process.env.VUE_APP_AUTH_CLIENT_ID
            });
            window.location.href = process.env.VUE_APP_AUTH_URL + "?" + params;
        },
        set_mun: function () {
            var mun = utils.generate_id() + "" + utils.uniqid() + "" + utils.generate_id() + "" + utils.generate_id() + "" + utils.uniqid() + "" + utils.generate_id() + "" + utils.generate_id();
            utils.utils_set_cookies("MUN", mun, 10);
            return mun;
        },
        init_app: async function () {
            var config = await auth.get_app_configs();
            if (_.isUndefined(config.error)) {
                Vue.set(store.state, "configs", config);
                Vue.set(store.state, "app_is_ready", true);
                const first_logs = await subscriber.checkFirstLogin()
                Vue.set(store.state.core, "first_login_configs", first_logs);
            }
        },
        auth_is_logged_in: function () {
            return (!_.isNull(utils.utils_get_cookies(utils.utils_get_config_item("cookies", "suat"))))
        },
        getIpAdress () {
            var config = {
                url: 'https://api.ipify.org/?format=json',
                type: "get",
                data: {},
                show_error: true
            };
            const response = this.utils_async_ajax(config);
            return response
        },
        logout: function () {
            if (!confirm(utils.utils_get_config_message("logout_prevent"))) {
                return;
            }
            utils.utils_delete_cookies("MUST");
            window.localStorage.removeItem("me_info_");
            window.location.href = process.env.VUE_APP_URL;
        }
    }
};